import React, { Fragment, PureComponent } from 'react';
import { connect } from 'react-redux';
import {
    Paper, Table, TableBody, TableCell, TableHead, TableRow, withStyles,
} from '@material-ui/core';
import { Checkbox, Input } from 'antd';

import { table_styles } from '../../../../components/TableStyles';
import { getBikeModelVariantsRequest } from '../redux/actions/get_bike_model_variants.actions';
import { changeBikeModelVariantRequest } from '../redux/actions/change_bike_model_variants.actions';
import { history } from '../../../../config/history';

const mapStateToProps = (state) => {
    const { variants, loading } = state.PlatformManagement.Bike_management;
    return { variants, loading };
};

export default connect(mapStateToProps, null)(withStyles(table_styles)(class BikeVariants extends PureComponent {
    state = {
        show_margins: false,
    };

    componentDidMount() {
        const { dispatch } = this.props;
        dispatch(getBikeModelVariantsRequest(history.location.pathname.slice(-24)));
    }

    handleChangeVariants = (value, key, variant_id, nested_key) => {
        this.props.dispatch(changeBikeModelVariantRequest(variant_id, key, value, nested_key));
    };

    styles = {
        table: {
            cells: {},
        },
        input: {
            width: '100%',
            maxWidth: 75,
        },
        checkbox: {
            marginLeft: 15,
        },
    };

    handleShowMargins = e => this.setState({ show_margins: e.target.checked });

    render() {
        const { variants, classes: { root1, tableWrapper, table } } = this.props;

        const titles = this.state.show_margins
            ? ['Year', 'Margin Q1', 'Margin Q2', 'Margin Q3', 'Margin Q4', 'Stock Limit', 'Min Price', 'Max Price', 'Hot List', 'Hot Margin', 'Cold List', 'Cold Margin']
            : ['Year', 'Stock Limit', 'Min Price', 'Max Price', 'Hot List', 'Hot Margin', 'Cold List', 'Cold Margin'];


        return (
            <Fragment>
                <Checkbox style={{ margin: '10px 0 10px 15px' }} checked={this.state.show_margins} onChange={this.handleShowMargins}>Show Margins</Checkbox>

                <Paper className={root1}>
                    <div className={tableWrapper}>
                        <Table className={table}>
                            <TableHead>
                                <TableRow>{titles.map((title, index) => <TableCell style={{ fontSize: '13px' }} key={index}>{title}</TableCell>)}</TableRow>
                            </TableHead>
                            <TableBody>
                                {variants && variants.map((variant, index) => (
                                    <TableRow key={index}>
                                        <TableCell style={this.styles.table.cells}>{variant.year}</TableCell>
                                        {
                                            this.state.show_margins
                                            && (
                                                <Fragment>
                                                    <TableCell style={this.styles.table.cells}>
                                                        <Input
                                                            style={this.styles.input}
                                                            type="number"
                                                            size="small"
                                                            defaultValue={variant.margin_by_quarter.q1}
                                                            onBlur={event => this.handleChangeVariants(event.target.value, 'margin_by_quarter.q1', variant._id)}
                                                        />
                                                    </TableCell>
                                                    <TableCell style={this.styles.table.cells}>
                                                        <Input
                                                            style={this.styles.input}
                                                            type="number"
                                                            size="small"
                                                            defaultValue={variant.margin_by_quarter.q2}
                                                            onBlur={event => this.handleChangeVariants(event.target.value, 'margin_by_quarter.q2', variant._id)}
                                                        />
                                                    </TableCell>
                                                    <TableCell style={this.styles.table.cells}>
                                                        <Input
                                                            style={this.styles.input}
                                                            type="number"
                                                            size="small"
                                                            defaultValue={variant.margin_by_quarter.q3}
                                                            onBlur={event => this.handleChangeVariants(event.target.value, 'margin_by_quarter.q3', variant._id)}
                                                        />
                                                    </TableCell>
                                                    <TableCell style={this.styles.table.cells}>
                                                        <Input
                                                            style={this.styles.input}
                                                            type="number"
                                                            size="small"
                                                            defaultValue={variant.margin_by_quarter.q4}
                                                            onBlur={event => this.handleChangeVariants(event.target.value, 'margin_by_quarter.q4', variant._id)}
                                                        />
                                                    </TableCell>
                                                </Fragment>
                                            )
                                        }
                                        <TableCell style={this.styles.table.cells}>
                                            <Input
                                                style={this.styles.input}
                                                type="number"
                                                size="small"
                                                defaultValue={variant.stock_limit}
                                                onBlur={event => this.handleChangeVariants(event.target.value, 'stock_limit', variant._id)}
                                            />
                                        </TableCell>
                                        <TableCell style={this.styles.table.cells}>
                                            <Input
                                                style={this.styles.input}
                                                type="number"
                                                size="small"
                                                defaultValue={variant.guide_price.min_price}
                                                onBlur={event => this.handleChangeVariants(event.target.value, 'guide_price.min_price', variant._id)}
                                            />
                                        </TableCell>
                                        <TableCell style={this.styles.table.cells}>
                                            <Input
                                                style={this.styles.input}
                                                type="number"
                                                size="small"
                                                defaultValue={variant.guide_price.max_price}
                                                onBlur={event => this.handleChangeVariants(event.target.value, 'guide_price.max_price', variant._id)}
                                            />
                                        </TableCell>
                                        <TableCell style={this.styles.table.cells}>
                                            <Checkbox
                                                style={this.styles.checkbox}
                                                checked={variant.is_hot}
                                                onChange={event => this.handleChangeVariants(event.target.checked, 'is_hot', variant._id)}
                                            />
                                        </TableCell>
                                        <TableCell style={this.styles.table.cells}>
                                            <Input
                                                style={this.styles.input}
                                                type="number"
                                                size="small"
                                                defaultValue={variant.hot_margin}
                                                onBlur={event => this.handleChangeVariants(event.target.value, 'hot_margin', variant._id)}
                                            />
                                        </TableCell>
                                        <TableCell style={this.styles.table.cells}>
                                            <Checkbox
                                                style={this.styles.checkbox}
                                                checked={variant.is_no_buy}
                                                onChange={event => this.handleChangeVariants(event.target.checked, 'is_no_buy', variant._id)}
                                            />
                                        </TableCell>
                                        <TableCell style={this.styles.table.cells}>
                                            <Input
                                                style={this.styles.input}
                                                type="number"
                                                size="small"
                                                defaultValue={variant.cold_margin}
                                                onBlur={event => this.handleChangeVariants(event.target.value, 'cold_margin', variant._id)}
                                            />
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </div>
                </Paper>
            </Fragment>
        );
    }
}));



// WEBPACK FOOTER //
// ./src/modules/PlatformManagement/Bike_model_update/components/BikeVariants.js